/* DOUBLE "Romantic maison" interactions (Wave 6). Vanilla, no dependencies. */
(function () {
  'use strict';
  var doc = document.documentElement;
  var body = document.body;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Header: measure, transparent-on-hero, frosted when scrolled ---------- */
  function measure() {
    var header = document.querySelector('.section-header');
    var bar = document.querySelector('.dbl-bar');
    if (header) doc.style.setProperty('--dbl-header-h', header.offsetHeight + 'px');
    doc.style.setProperty('--dbl-bar-h', (bar ? bar.offsetHeight : 0) + 'px');
  }
  function onScroll() {
    body.classList.toggle('dbl-scrolled', window.scrollY > 8);
  }
  measure();
  onScroll();
  window.addEventListener('resize', measure, { passive: true });
  window.addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('shopify:section:load', measure);

  // Solid header while a mega menu is open; open menus on hover with a mouse (click still works)
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  document.querySelectorAll('.header__inline-menu details').forEach(function (d) {
    d.addEventListener('toggle', function () {
      body.classList.toggle('dbl-menu-open', !!document.querySelector('.header__inline-menu details[open]'));
    });
    if (!canHover) return;
    var summary = d.querySelector('summary');
    if (!summary) return;
    var closeTimer, auto = false;
    var toggle = function () { auto = true; summary.click(); auto = false; };
    // With a mouse the menu follows the pointer, so a click on an already-open menu must not close it.
    summary.addEventListener('click', function (e) { if (!auto && d.open) e.preventDefault(); }, true);
    d.addEventListener('mouseenter', function () {
      clearTimeout(closeTimer);
      if (!d.open) toggle();
    });
    d.addEventListener('mouseleave', function () {
      closeTimer = setTimeout(function () { if (d.open) toggle(); }, 200);
    });
  });

  /* ---------- Announcement bar rotation ---------- */
  document.querySelectorAll('.dbl-bar').forEach(function (bar) {
    var msgs = bar.querySelectorAll('.dbl-bar__msg');
    if (msgs.length < 2) return;
    var i = 0, started = false;
    var speed = (parseInt(bar.dataset.speed, 10) || 5) * 1000;
    // Wave 23: rotate only after the first scroll or tap. A message that fades in later would otherwise count as the
    // page's main paint (LCP) and make Google's speed score think the page took 6-7 seconds.
    var events = ['scroll', 'pointerdown', 'keydown', 'touchstart'];
    function start() {
      if (started) return;
      started = true;
      events.forEach(function (ev) { window.removeEventListener(ev, start); });
      setInterval(function () {
        msgs[i].classList.remove('is-active');
        i = (i + 1) % msgs.length;
        msgs[i].classList.add('is-active');
      }, speed);
    }
    events.forEach(function (ev) { window.addEventListener(ev, start, { passive: true }); });
  });

  /* ---------- Reveal on scroll ---------- */
  var revealEls = document.querySelectorAll('[data-dbl-reveal]');
  if ('IntersectionObserver' in window && !reduce) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- Hero parallax (desktop only, transform only) ---------- */
  var hero = document.querySelector('.dbl-hero');
  if (hero && !reduce && window.matchMedia('(min-width: 750px)').matches) {
    var layers = hero.querySelectorAll('.dbl-hero__parallax');
    var content = hero.querySelector('.dbl-hero__content');
    var ticking = false;
    var update = function () {
      var y = Math.min(window.scrollY, hero.offsetHeight);
      layers.forEach(function (l, idx) {
        l.style.transform = 'translate3d(0,' + (y * (0.16 + idx * 0.05)).toFixed(1) + 'px,0)';
      });
      if (content) {
        content.style.transform = 'translate3d(0,' + (y * 0.32).toFixed(1) + 'px,0)';
        content.style.opacity = Math.max(0, 1 - y / (hero.offsetHeight * 0.55)).toFixed(3);
      }
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
  }

  /* ---------- Approximate local-currency prices (visitors outside the UAE) ----------
     Stopgap until Shopify Payments enables real local currencies: checkout still charges AED, and the line says so.
     window.dblFx = { c: country, l: language, r: rates per 1 AED } comes from snippets/dbl-fx-config.liquid. */
  var FX_CUR = (function () {
    var m = {}, groups = {
      EUR: 'AD AT BE BG CY DE EE ES FI FR GR HR IE IT LT LU LV MC ME MT NL PT SI SK SM VA XK',
      USD: 'US EC SV PA PR TL ZW FM MH PW', GBP: 'GB IM JE GG', CHF: 'CH LI', NOK: 'NO SJ', DKK: 'DK GL FO',
      AUD: 'AU NR TV KI', NZD: 'NZ CK NU', XOF: 'BJ BF CI GW ML NE SN TG', XAF: 'CM CF TD CG GQ GA', XCD: 'AG DM GD KN LC VC AI MS'
    };
    Object.keys(groups).forEach(function (cur) { groups[cur].split(' ').forEach(function (c) { m[c] = cur; }); });
    ('SE:SEK PL:PLN CZ:CZK HU:HUF RO:RON IS:ISK RS:RSD BA:BAM MK:MKD AL:ALL MD:MDL UA:UAH BY:BYN RU:RUB GE:GEL AM:AMD ' +
     'AZ:AZN KZ:KZT UZ:UZS KG:KGS TJ:TJS TM:TMT TR:TRY IL:ILS PS:ILS JO:JOD LB:LBP SY:SYP IQ:IQD IR:IRR SA:SAR KW:KWD ' +
     'QA:QAR BH:BHD OM:OMR YE:YER EG:EGP LY:LYD TN:TND DZ:DZD MA:MAD SD:SDG ET:ETB KE:KES UG:UGX TZ:TZS RW:RWF NG:NGN ' +
     'GH:GHS ZA:ZAR NA:NAD BW:BWP ZM:ZMW MZ:MZN AO:AOA MU:MUR SC:SCR MG:MGA CA:CAD MX:MXN GT:GTQ HN:HNL NI:NIO CR:CRC ' +
     'DO:DOP JM:JMD TT:TTD BS:BSD BB:BBD HT:HTG CU:CUP CO:COP VE:VES PE:PEN BO:BOB CL:CLP AR:ARS UY:UYU PY:PYG BR:BRL ' +
     'GY:GYD SR:SRD JP:JPY KR:KRW CN:CNY HK:HKD MO:MOP TW:TWD MN:MNT SG:SGD MY:MYR TH:THB VN:VND KH:KHR LA:LAK MM:MMK ' +
     'PH:PHP ID:IDR BN:BND IN:INR PK:PKR BD:BDT LK:LKR NP:NPR MV:MVR AF:AFN BT:BTN FJ:FJD PG:PGK WS:WST TO:TOP')
      .split(' ').forEach(function (p) { var kv = p.split(':'); m[kv[0]] = kv[1]; });
    return m;
  })();
  function fxText(el, fx, cur, locale) {
    var aed = parseInt(el.getAttribute('data-aed'), 10) / 100;
    if (!aed || !fx.r[cur]) return;
    var value = aed * fx.r[cur];
    var txt;
    try {
      // language-only locale keeps symbols unambiguous for international visitors: CA$, A$, NZ$, €, £ (plain $ only for USD)
      txt = new Intl.NumberFormat(locale, { style: 'currency', currency: cur, currencyDisplay: 'symbol', maximumFractionDigits: 0 }).format(value);
    } catch (e) {
      txt = Math.round(value).toLocaleString() + ' ' + cur;
    }
    var ru = fx.l === 'ru';
    var note = el.classList.contains('dbl-fx--total')
      ? (ru ? ' · оплата в AED по курсу вашего банка' : ' · charged in AED at your bank’s rate')
      : (ru ? ' · оплата в AED' : ' · charged in AED');
    el.textContent = '≈ ' + txt + note;
    el.setAttribute('title', ru ? 'Примерная цена в вашей валюте. Оплата списывается в дирхамах ОАЭ (AED).' : 'Approximate price in your currency. You are charged in UAE dirhams (AED).');
    el.setAttribute('data-done', '1');
  }
  var fx = window.dblFx;
  if (fx && fx.r) {
    var fxCur = FX_CUR[fx.c];
    if (fxCur && fxCur !== 'AED' && fx.r[fxCur]) {
      var fxLocale = fx.l === 'ru' ? 'ru' : 'en';
      var fxRun = function (root) {
        (root || document).querySelectorAll('.dbl-fx:not([data-done])').forEach(function (el) { fxText(el, fx, fxCur, fxLocale); });
      };
      fxRun();
      // prices are re-rendered when a variant changes or the bag updates
      new MutationObserver(function () { fxRun(); }).observe(document.body, { childList: true, subtree: true });
    }
  }

  /* ---------- Country suggestion: remembered country differs from where the visitor is ----------
     Shopify keeps the first country in a cookie. If the visitor is now somewhere else, offer (never force) a switch,
     so the currency estimate, delivery times and messages match. Uses Shopify's own location detection. */
  (function () {
    var loc = window.dblLoc;
    if (!loc || !window.fetch) return;
    var ru = loc.l === 'ru';
    var key = 'dblGeoAsked:' + loc.c;
    try { if (sessionStorage.getItem(key)) return; } catch (e) {}
    // One dialog at a time: Shopify's cookie banner (same bottom spot) is answered first, then this bar slides in.
    var cookieOpen = function () {
      var b = document.getElementById('shopify-pc__banner');
      if (!b) return false;
      var cs = getComputedStyle(b);
      return cs.display !== 'none' && cs.visibility !== 'hidden' && b.getBoundingClientRect().height > 0;
    };
    var whenClear = function (fn) {
      var start = function () {
        if (!cookieOpen()) return fn();
        var t = setInterval(function () { if (!cookieOpen()) { clearInterval(t); setTimeout(fn, 600); } }, 700);
      };
      // the banner is injected after load, so give it a moment to appear before deciding the spot is free
      // Wave 28 (Clarity): never over the first screen on arrival; wait until the visitor scrolls past it, or 20 s
      var later = function () {
        var gone = false, t20;
        var go = function () { if (gone) return; gone = true; window.removeEventListener('scroll', onScroll); clearTimeout(t20); setTimeout(start, 400); };
        var onScroll = function () { if (window.scrollY > window.innerHeight * 0.6) go(); };
        t20 = setTimeout(go, 20000);
        window.addEventListener('scroll', onScroll, { passive: true });
      };
      if (document.readyState === 'complete') later(); else window.addEventListener('load', later);
    };
    fetch('/browsing_context_suggestions.json?country[enabled]=true', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var det = d && d.detected_values && d.detected_values.country;
        if (!det || !det.handle || det.handle === loc.c) return;
        var esc = function (t) { var d = document.createElement('span'); d.textContent = t || ''; return d.innerHTML; };
        var name = esc(det.name);
        var here = esc(loc.n);
        var bar = document.createElement('div');
        bar.className = 'dbl-geo';
        bar.setAttribute('role', 'dialog');
        bar.innerHTML =
          '<p>' + (ru ? 'Вы сейчас в стране <em>' + name + '</em>' : 'You’re browsing from <em>' + name + '</em>') +
          '<small>' + (ru ? 'Переключить, чтобы видеть доставку и цены для этой страны?'
                          : 'Switch to see delivery and prices for this country?') + '</small></p>' +
          '<button type="button" class="dbl-geo__yes">' + (ru ? 'Да, переключить' : 'Switch') + '</button>' +
          '<button type="button" class="dbl-geo__no" aria-label="' + (ru ? 'Закрыть' : 'Close') + '">' +
          (ru ? 'Оставить «' + here + '»' : 'Keep ' + here) + '</button>';
        whenClear(function () {
          document.body.appendChild(bar);
          document.body.classList.add('dbl-geo-open');
          requestAnimationFrame(function () { requestAnimationFrame(function () { bar.classList.add('is-in'); }); });
        });
        var done = function () { try { sessionStorage.setItem(key, '1'); } catch (e) {} };
        bar.querySelector('.dbl-geo__no').addEventListener('click', function () {
          done(); bar.classList.remove('is-in'); document.body.classList.remove('dbl-geo-open');
          setTimeout(function () { bar.remove(); }, 700);
        });
        bar.querySelector('.dbl-geo__yes').addEventListener('click', function () {
          done();
          var body = new URLSearchParams({ form_type: 'localization', _method: 'put', country_code: det.handle,
            return_to: location.pathname + location.search });
          fetch('/localization', { method: 'POST', body: body, credentials: 'same-origin' })
            .then(function () { location.reload(); }, function () { location.reload(); });
        });
      })
      .catch(function () {});
  })();

  /* ---------- Product rail: arrows, progress, mouse drag ---------- */
  document.querySelectorAll('[data-dbl-rail]').forEach(function (rail) {
    var track = rail.querySelector('.dbl-rail__track');
    var prev = rail.querySelector('[data-dir="prev"]');
    var next = rail.querySelector('[data-dir="next"]');
    var bar = rail.querySelector('.dbl-rail__progress span');
    if (!track) return;
    var step = function () {
      var item = track.querySelector('.dbl-rail__item');
      return item ? item.getBoundingClientRect().width + 14 : 300;
    };
    var sync = function () {
      var max = track.scrollWidth - track.clientWidth;
      var p = max > 0 ? track.scrollLeft / max : 0;
      if (bar) {
        var w = Math.max(0.12, track.clientWidth / track.scrollWidth);
        bar.style.width = (w * 100).toFixed(2) + '%';
        bar.style.transform = 'translateX(' + (p * (1 / w - 1) * 100).toFixed(2) + '%)';
      }
      if (prev) prev.disabled = track.scrollLeft < 4;
      if (next) next.disabled = track.scrollLeft > max - 4;
    };
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 2, behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 2, behavior: 'smooth' }); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync, { passive: true });
    sync();

    // Mouse drag (touch scrolls natively)
    var down = false, moved = false, startX = 0, startLeft = 0;
    track.addEventListener('pointerdown', function (e) {
      if (e.pointerType !== 'mouse') return;
      down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
    });
    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (!moved && Math.abs(dx) > 6) { moved = true; track.classList.add('is-dragging'); }
      if (moved) track.scrollLeft = startLeft - dx;
    });
    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      if (moved) {
        setTimeout(function () { track.classList.remove('is-dragging'); }, 30);
      }
    });
    track.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
  });
})();

/* Hero film (5 Oct 2026): desktop only, never on phones; nothing under reduced motion (the first frame stays).
   Picks the lightest MP4 rendition tall enough for the screen, fades in once it really plays, pauses off-screen,
   and a pause button (WCAG 2.2.2) that the visitor's choice overrides the auto-resume. */
(function () {
  var v = document.querySelector('[data-dbl-film]');
  if (!v) return;
  var desk = window.matchMedia('(min-width: 750px)');
  var calm = window.matchMedia('(prefers-reduced-motion: reduce)');
  var btn = document.querySelector('[data-dbl-film-toggle]');
  var userPaused = false, inView = true;

  function load() {
    if (v.getAttribute('src')) return true;
    var list = [].slice.call(v.querySelectorAll('source[data-src]'));
    if (!list.length) return false;
    list.sort(function (a, b) { return a.getAttribute('data-h') - b.getAttribute('data-h'); });
    var need = Math.min(1080, Math.round(v.clientHeight * (window.devicePixelRatio || 1)));
    var pick = list.filter(function (s) { return +s.getAttribute('data-h') >= need; })[0] || list[list.length - 1];
    v.src = pick.getAttribute('data-src');
    return true;
  }
  function play() {
    if (!desk.matches || calm.matches || userPaused || !inView) return;
    if (!load()) return;
    var p = v.play();
    if (p && p.catch) p.catch(function () {});
  }
  function setBtn(paused) {
    if (!btn) return;
    btn.classList.toggle('is-paused', paused);
    btn.setAttribute('aria-label', btn.getAttribute(paused ? 'data-play' : 'data-pause'));
  }

  v.addEventListener('playing', function () { v.classList.add('is-playing'); if (btn) btn.hidden = false; });
  if (btn) btn.addEventListener('click', function () {
    if (v.paused) { userPaused = false; setBtn(false); play(); }
    else { userPaused = true; v.pause(); setBtn(true); }
  });
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      inView = es[0].isIntersecting;
      if (inView) play(); else if (!v.paused) v.pause();
    }, { threshold: 0.15 }).observe(v);
  }
  var onChange = function () { if (desk.matches && !calm.matches) play(); else if (!v.paused) v.pause(); };
  [desk, calm].forEach(function (m) { m.addEventListener ? m.addEventListener('change', onChange) : m.addListener(onChange); });
  play();
})();


/* Wave 25: where a chat button sits, so taps are tracked without any code in the customer's message. */
window.dblWaWhere = function (el) {
  var p = location.pathname.replace(/^\/(ru|ar)(?=\/|$)/, '') || '/';
  if (el.closest && el.closest('.dbl-wa__btn')) {
    var b = el.closest('.dbl-wa__btn');
    return { where: b.dataset.state === 'soldout' ? 'product_soldout' : 'product', product: (p.match(/^\/products\/([^/?#]+)/) || [])[1] || '' };
  }
  if (el.closest && el.closest('.dbl-cart-help, cart-drawer, .cart-drawer')) return { where: 'bag', product: '' };
  /* Wave 28: the hero button, the menu row and the round bubble */
  if (el.closest && el.closest('.dbl-hero')) return { where: 'home_hero', product: '' };
  if (el.closest && el.closest('.menu-drawer, .dbl-drawer-wa')) return { where: 'menu', product: '' };
  if (el.closest && el.closest('#chat-bubble, .whatsapp-widget')) return { where: 'float', product: '' };
  if (el.closest && el.closest('.announcement-bar, [id*="announcement"]')) return { where: 'top_bar', product: '' };
  var w = p === '/' ? 'home' : /^\/collections\//.test(p) ? 'collection' : /^\/products\//.test(p) ? 'product_other' : /^\/pages\//.test(p) ? 'page' : 'other';
  return { where: w, product: (p.match(/^\/products\/([^/?#]+)/) || [])[1] || '' };
};

/* Chat-intent clicks for GA4 (and Google Ads as secondary goals): whatsapp_click and instagram_click.
   Sends the button's DOUBLE code (e.g. WEB-PDP) from the WhatsApp pre-fill, never any customer data. */
(function () {
  function send(name, params) {
    try { if (typeof window.gtag === 'function') window.gtag('event', name, Object.assign({ transport_type: 'beacon' }, params)); } catch (e) {}
  }
  function codeOf(href) {
    var m = /[?&]text=([^&]*)/.exec(href || '');
    if (!m) return '';
    var text = decodeURIComponent(m[1].replace(/\+/g, ' '));
    var c = /\b(WEB-[A-Z-]+|C\d{2}[a-z]?)\b/.exec(text);
    return c ? c[1] : '';
  }
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest && e.target.closest('a[href], .whatsapp-widget');
    if (!el) return;
    var href = el.getAttribute('href') || '';
    if (/wa\.me|whatsapp\.com/i.test(href) || (!href && /whatsapp/i.test(el.className || ''))) {
      var w = window.dblWaWhere(el); send('whatsapp_click', { link_url: href.split('?')[0], wa_where: w.where, wa_product: w.product, page_path: location.pathname });
    } else if (/ig\.me|instagram\.com/i.test(href)) {
      send('instagram_click', { link_url: href.split('?')[0], page_path: location.pathname });
    }
  }, true);
})();
